import {Grid} from '@quarks';
import styled from 'styled-components';

export const StyledGrid = styled(Grid)`
  align-items: flex-start;
  grid-template-columns: [full-start] 100% [full-end];
  grid-template-rows: [full-start] 100% [full-end];
  height: 100%;
`;
